export function useCriteriaToParam(criteria) {
    return criteria.replace(/[A-Z]/g, (c, index, str) => { return ( /[A-Z]/g.test(str[index-1]) || index === 0 ) ? c.toLowerCase() : '_' + c.toLowerCase() })
}